import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./deposit.css";

import Button from "../../components/button/button";
import Header from "../../components/header/header";
import { ThemeProvider } from "../../components/header/header";

import note from "./img/note.svg";

const Deposit = () => {
  const navigate = useNavigate();

  const [inputValue, setInputValue] = useState("$");
  const [openModal, setOpenModal] = useState(false);
  const [noteText, setNoteText] = useState("");
  const [tempNoteText, setTempNoteText] = useState("");
  const [isShaking, setIsShaking] = useState(false);

  const handleButtonClick = (value) => {
    if (value === "<") {
      setInputValue((prev) => {
        let newValue = prev.slice(0, -1);
        if (!newValue.startsWith("$")) {
          newValue = "$";
        }
        return newValue;
      });
    } else {
      setInputValue((prev) => {
        const newValue = prev + value;
        return newValue;
      });
    }
  };

  const handleOpenModal = () => {
    setTempNoteText(noteText);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setNoteText(tempNoteText);
    setOpenModal(false);
  };

  const handlePage = (e) => {
    e?.preventDefault();

    if (inputValue === "$0" || inputValue.match(/^\$0\d+/)) {
      setIsShaking(true);
      setTimeout(() => setIsShaking(false), 300);
      return;
    }

    localStorage.setItem("note", noteText);
    localStorage.setItem("amountValue", inputValue);
    navigate("/payment");
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
  
    if (!value.startsWith("$")) {
      setInputValue(value ? `$${value}` : "$");
    } else {
      setInputValue(value);
    }
  };

  return (
    <>
      <ThemeProvider>
        <Header />
      </ThemeProvider>
      <div className="container">
        <div className="depositFormWrap">
          <h1 className="title">Deposit</h1>
          <form className="depositForm">
            <div>
              <input
                className={`depositValue ${isShaking ? "shake" : ""}`}
                type="text"
                value={inputValue}
                onChange={handleInputChange}
              />
              <div className="currency">USD</div>
              <div className="keybord">
                {[
                  "1",
                  "2",
                  "3",
                  "4",
                  "5",
                  "6",
                  "7",
                  "8",
                  "9",
                  ".",
                  "0",
                  "<",
                ].map((num) => (
                  <button
                    type="button"
                    className="keybordButton"
                    key={num}
                    onClick={() => handleButtonClick(num)}
                  >
                    {num}
                  </button>
                ))}
              </div>
              {!noteText && (
                <div className="note" onClick={() => handleOpenModal()}>
                  <div>Note (Optional)</div>
                  <img src={note} alt="note" />
                </div>
              )}
              {noteText && (
                <div className="textNote" onClick={() => handleOpenModal()}>
                  <span className="spanBg"></span>
                  <span className="spanText">Note</span>
                  {noteText}
                </div>
              )}
            </div>
            <Button text="Send Deposit" onClick={handlePage} disabled={inputValue === '$'} />
          </form>
        </div>

        {openModal && (
          <div className="modalNoteWrap">
            <div className="modalNote">
              <div className="title titleModal">Add note</div>
              <textarea
                className="modalTextarea"
                placeholder="Add your note here.."
                value={tempNoteText}
                onChange={(e) => setTempNoteText(e.target.value)}
              ></textarea>
              <Button text="Save" onClick={() => handleCloseModal()} />
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Deposit;
